import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedStaffListList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface IUseListStaff {
  searchTerm?: string;
  isCoach?: boolean;
  ordering?: string;
  isActive?: string;
  gymId?: string;
  loginEnabled?: string;
  csvExport?: string;
  enabled?: boolean;
  limit?: string;
}

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey?: (string | undefined | string[])[];
}

export default function useListStaff({
  searchTerm,
  isCoach,
  ordering,
  isActive,
  gymId,
  loginEnabled,
  csvExport,
  enabled = true,
  limit = '20',
}: IUseListStaff): UseInfiniteQueryResult<AxiosResponse<PaginatedStaffListList>> {
  const fetchStaffs = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedStaffListList>> => {
    const params = pageParam;

    if (gymId) {
      params.gym_id = gymId;
    }

    if (searchTerm) {
      params.search = searchTerm;
    }

    if (!!isCoach) {
      params.is_coach = isCoach ? 'True' : 'False';
    }

    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
    }

    if (isActive !== undefined) {
      params.is_active = isActive;
    }

    if (loginEnabled) {
      params.profile__login_enabled = loginEnabled;
    }

    return client.get(`staff/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(
    ['staff', searchTerm, ordering, isActive, gymId, csvExport, loginEnabled],
    fetchStaffs,
    {
      getNextPageParam: page => {
        return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
      },
      enabled,
    },
  );
}
